export enum Roles {
    SUPERADMIN = "Superadmin",
    GUEST = "Guest",
  }